import { ButtonHTMLAttributes, FC } from 'react';
import { User } from 'lucide-react';
import styled from 'styled-components';

import theme from 'theme';
import { SKEW_ANGLE } from '@utils/constants';
import { formatNumber } from '@utils/index';
import { PremierText } from '@components/text/Text';
import TouchableOpacity from '@components/buttons/TouchableOpacity';

const Container = styled(TouchableOpacity)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  background: linear-gradient(
    120deg,
    ${theme.colors.red[500]} 0%,
    ${theme.colors.purple[500]} 50%,
    ${theme.colors.blue[500]} 80%
  );
  box-shadow: 2px 2px 4px 0 ${theme.colors.black}${theme.opacity[40]};

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 48px;
    height: 48px;
  }
`;

const NumberOfParticipants = styled.div`
  position: absolute;
  top: 0;
  left: -8px;
  max-width: 48px;
  min-width: 32px;
  max-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.white};
  transform: skew(-${SKEW_ANGLE}deg);
`;

const NumberOfParticipantsText = styled(PremierText)`
  padding: 0 4px;
  font-size: ${({ theme }) => theme.fonts.fontSize.xs};
  color: ${theme.colors.black};
  transform: skew(${SKEW_ANGLE}deg);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

type Props = {
  count?: number;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const ParticipantsButton: FC<Props> = ({ count, ...props }) => {
  return (
    <Container {...props}>
      {!!count && (
        <NumberOfParticipants>
          <NumberOfParticipantsText>
            {formatNumber(count, 0) || 0}
          </NumberOfParticipantsText>
        </NumberOfParticipants>
      )}

      <User size={24} color={theme.colors.white} />
    </Container>
  );
};

export default ParticipantsButton;
